import { render, staticRenderFns } from "./attachment-file-list.vue?vue&type=template&id=2d38678c"
import script from "./attachment-file-list.vue?vue&type=script&lang=js"
export * from "./attachment-file-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports